import { render, staticRenderFns } from "./choose.vue?vue&type=template&id=617b3e4c&scoped=true&"
import script from "./choose.vue?vue&type=script&lang=js&"
export * from "./choose.vue?vue&type=script&lang=js&"
import style0 from "./choose.vue?vue&type=style&index=0&id=617b3e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b3e4c",
  null
  
)

export default component.exports